module.exports = __webpack_public_path__ + "static/2019426:2ace0725733a716000c6/img/square_1x.507fc60.png";


//////////////////
// WEBPACK FOOTER
// ./app/src/assets/images/home/square_1x.png
// module id = ETCH
// module chunks = 41